import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  transferId?: string
  providerId: string
}

type MutationResponse = {
  signingUrl: string
}

export function useCreateReimbursement() {
  const queryClient = useQueryClient()

  return useMutation<MutationResponse, unknown, MutationFnParams>({
    mutationFn: async ({ transferId, providerId }) => {
      const response = await fetcher(
        `/Reimbursement/Create`,
        {
          method: "POST",
          body: JSON.stringify({
            transferId,
            providerId,
          }),
        },
        {
          useAccessToken: true,
        }
      )
      const json = await response.json()

      return json
    },
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({ queryKey: ["transactionDetails", variables.transferId] })
    },
  })
}
